/**
 * Note: Before using this,it needs to be declared at least one time in the className in the DOM to make the tailwind can detect.
 * In this case, h-14 is already declared in TopNavigationStyled.
 */
export const TOP_NAV_HEIGHT_CLASSNAME = 'h-14';
/**
 * Note: Before it needs to be declared at least one time in the className in the DOM to make the tailwind can detect.
 * In this case, z-40 is already declared in TopNavigationStyled.
 */
export const TOP_NAV_Z_CLASSNAME = 'z-40';

/**
 * Note: This constant is useful for handling scrollIntoView. The tops navigation is now sticky position.
 * When scrollIntoView element on the page, we need to add this to the offset to make it scroll to position correctly.
 */
export const TOP_NAV_HEIGHT: number = 56;

export const TOP_NAV_MENU_LABEL = 'เมนู';
